import { TextField, TextFieldProps } from '@mui/material'
import { styled } from '@mui/material/styles'

const WhiteTextField = styled((props: Omit<TextFieldProps, 'variant'>) => (
    <TextField variant="filled" {...props} />
))(({ theme }) => ({
    '& .MuiInputBase-root': {
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: '#fff',
        },
        '&.Mui-focused': {
            backgroundColor: '#ffff',
            borderColor: '#fff',
        },
    },
}))

export default WhiteTextField
